import { getHostname } from './getHostname';
const DESIGN_SYSTEM_SERVER_URLS = {
    production: 'https://design-system-bff.zapier.com',
    staging: 'https://design-system-bff.zapier-staging.com',
    localhost: 'http://localhost:8000',
};
export const getServerUrl = (bffHostname) => {
    const hostname = getHostname();
    if (hostname.endsWith('zapier.com')) {
        return DESIGN_SYSTEM_SERVER_URLS.production;
    }
    else if (hostname.endsWith('zapier-staging.com')) {
        if (bffHostname) {
            return bffHostname;
        }
        return DESIGN_SYSTEM_SERVER_URLS.staging;
    }
    else if (hostname === 'localhost') {
        if (bffHostname) {
            return bffHostname;
        }
        return DESIGN_SYSTEM_SERVER_URLS.staging;
    }
    return DESIGN_SYSTEM_SERVER_URLS.staging;
};
//# sourceMappingURL=getServerUrl.js.map
// @zapier/universal-layout@12.1.13 (07faf2fcc)
